import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  background: linear-gradient(90deg, #00BBD3 0%, #33E4DB 100%);
  padding: 40px 0 60px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  font-family: 'Noto Sans Thai', sans-serif !important;
  font-weight: bold;
  * {
    font-family: 'Noto Sans Thai', sans-serif !important;
    font-weight: bold;
  }
`;

const LogoContainer = styled.div`
  position: relative;
  z-index: 2;
`;

const Logo = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
`;

const PatternSVG = styled.div`
  position: absolute;
  top: -10%;
  left: -10%;
  width: 120%;
  height: 120%;
  opacity: 0.3;
  z-index: 1;
  
  svg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Header = () => {
  return (
    <HeaderContainer>
      <PatternSVG>
        <svg xmlns="http://www.w3.org/2000/svg" width="440" height="270" viewBox="0 0 440 270" fill="none">
          <path d="M380.447 -58L115 269.5H202.908L423.539 -2.84211L380.447 -58Z" fill="#D9D9D9"/>
          <path d="M72.7697 111.783L149.474 205.724L105.52 259.158L-16 111.783H72.7697Z" fill="#D9D9D9"/>
          <path d="M139.132 111.783L183.947 163.493L227.039 111.783H139.132Z" fill="#D9D9D9"/>
          <path d="M287.368 184.178L244.276 237.612L260.651 259.158L305.467 205.724L287.368 184.178Z" fill="#D9D9D9"/>
          <path d="M447.671 50.5921L270.132 269.5H358.039L455.428 149.704L447.671 50.5921Z" fill="#D9D9D9"/>
        </svg>
      </PatternSVG>
      <LogoContainer>
        <Logo src="./logo.png" alt="Logo" />
      </LogoContainer>
    </HeaderContainer>
  );
};

export default Header;